
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const AddRoomFeaturesForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  fields
}) => {
  
  return (
    <PageBody onSubmit={handleSubmit} headerchildren={
      <HeadingOne>Edit User</HeadingOne>
    }>
      {fields.map((field) => {

        if (field.type === "switch") {
          return (
            <Switch
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }
        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Update Room Feature"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddRoomFeaturesForm;
